var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edit-sci-application',{attrs:{"call-id":_vm.callId}})}
var staticRenderFns = []

export { render, staticRenderFns }